<template lang="pug">
	modal
		.card
			.card-header
				| Buscar gifs
				button.close(@click="cerrar") &times;
			.card-body.bg-light
				.input-group
					input.form-control(v-model="cadena", @keypress.enter="buscar")
					.input-group-append
						button.btn.btn-primary(@click="buscar")
							span.fa.fa-search
				.text-right.mt-2
					a(style="opacity: 0.5;cursor: pointer;", target="_blank", href="https://www.giphy.com") Powered by GIPHY
			
			.card-body
				.gif(v-for="(gif, i) in resultados", :key="i", style="vertical-align:top;")
					img(:src="gif.images.downsized_large.url", style="position: relative;display: block;width: 100%;", @click="adjuntar(gif)")
</template>

<script>
export default {
	data () {
		return {
			cadena: null,
			resultados: []
		}
	},
	methods: {
		buscar () {
			this.$http.post('muro/php/api/buscaGifs.php', {q: this.cadena})
				.then(res => {
					this.resultados = res.data.data
				})
				.catch(e => {
					console.error(e)
				})
		},
		adjuntar (gif) {
			this.$emit('adjuntar', gif)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>


<style scoped>
.gif {
	position: relative;
	display: inline-block !important;
	width: 200px;
	margin: 2px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/nueva/buscarGifs.vue